import { EditVoteCardKeys } from 'helpers/enums/Assembleia';
import { Col, ThreeDotsLoader } from 'plataforma-fundacao-componentes';
import styles from '../editarVotos.module.scss';

interface CardsProps {
  titleKey: EditVoteCardKeys;
  value: number;
  loading?: boolean;
}

export default function Cards({ titleKey, value, loading }: CardsProps) {
  return (
    <div className={styles['vote-cards']}>
      <h6>{titleKey}</h6>
      {loading ? (
        <Col style={{ padding: '10px 0' }}>
          <ThreeDotsLoader size={1} />
        </Col>
      ) : (
        <p>{value}</p>
      )}
    </div>
  );
}
